import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink } from "reactstrap";
import Scrollspy from "react-scrollspy";
import { Link } from "react-router-dom";

import logoCinza from "../assets/images/araucaria-logo-cinza.png";
import logoBrancoVerde from "../assets/images/araucaria-logo-branco-verde.png";

const NavBar = ({isDark}) => {
  const [isOpenMenu, setisOpenMenu] = useState(false);
  const [navClass, setnavClass] = useState("");

  const toggle = () => setisOpenMenu(!isOpenMenu);

  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setnavClass("nav-sticky");
    } else {
      setnavClass("");
    }
  }

  const isDarkClass = isDark ? "navbar-light" : "";

  return (
    <React.Fragment>
      <span>
        <nav
          className={
            "navbar navbar-expand-lg fixed-top " +
            isDarkClass +
            " sticky " +
            navClass
          }
          id="navbar"
        >
          <Container>
            <Link className="navbar-brand logo" to="/">
              <img
                src={logoBrancoVerde}
                alt="Araucária Solar"
                height="45"
                className="logo-light"
              />
              <img
                src={logoCinza}
                alt="Araucária Solar"
                height="45"
                className="logo-dark"
              />
            </Link>
            <NavbarToggler
              className="navbar-toggler"
              type="button"
              onClick={toggle}
            >
              <i className="mdi mdi-menu"></i>
            </NavbarToggler>
            <Collapse
              isOpen={isOpenMenu}
              className="navbar-collapse"
              id="navbarNav"
            >
              <Scrollspy
                offset={-18}
                items={[
                  "home",
                  "quem-somos",
                  "servicos",
                  "contato",
                ]}
                currentClassName="active"
                className="navbar-nav ms-auto navbar-center"
                id="mySidenav"
              >
                <li className="nav-item">
                  <NavLink href="#home">Início</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="#quem-somos">Quem Somos</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="#servicos">Serviços</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="#contato">Contato</NavLink>
                </li>
              </Scrollspy>
              <a href="#contato" className="btn btn-primary ms-lg-3">
                Orçamento Grátis
              </a>
            </Collapse>
          </Container>
        </nav>
      </span>
    </React.Fragment>
  );
};

export default NavBar;
